import { type SpeedKeyMessageIndicator } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/speed-key-messages/types';
import { ENGINE_COMPARISON_LIST } from '@/app/lcv/contents/spartan/engine/shared/22biturbo-specifications.data';

export const SPEED_VIDEO_END_PROGRESS = 0.999;
export const CLIP_CROSSFADE_MS = 1000;
export const BOX_STAGGER_MS = 600;
export const INDICATOR_FILL_MS = 1400;

export const VALUE_CLIMB_MS = 600;
export const HEADLINE_DELAY_MS =
  (ENGINE_COMPARISON_LIST.length - 1) * BOX_STAGGER_MS + INDICATOR_FILL_MS;

export const INDICATORS: SpeedKeyMessageIndicator[] = ['ring', 'ring', 'glow'];
